import RootModal from "@/components/RootModal/RootModal";
import useTranslation from "@/hooks/useTranslation";
import { Form, Input, InputRef, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { ReactNode, useRef, useState } from "react";
import { useAddProductScenario } from "../../../useProducts";

export default function AddScenarioAction({
  productId,
  children,
}: {
  productId: number;
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [form] = useForm<{ name: string }>();
  const t = useTranslation();
  const addScenario = useAddProductScenario();
  const ref = useRef<InputRef>(null);

  const onFocus = () => {
    ref.current?.focus();
  };

  const onSubmit = async () => {
    return form
      .validateFields()
      .then((scenario) => {
        addScenario.mutateAsync({ productId, scenario }).then(() => {
          message.success("Scenario added.");
          setIsOpen(false);
          form.resetFields();
        });
      })
      .catch(() => {
        message.error(t.errors.general);
      });
  };

  return (
    <>
      <span onClick={() => setIsOpen(!isOpen)}>{children}</span>
      <RootModal
        onCancel={() => setIsOpen(false)}
        open={isOpen}
        afterOpenChange={onFocus}
        width={400}
        title={"Add scenario"}
        onOk={onSubmit}
        okButtonProps={{ loading: addScenario.isLoading }}
      >
        <Form
          form={form}
          layout="vertical"
          onKeyUp={(e) => {
            if (e.code === "Enter") onSubmit();
          }}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true,
                message: `Name is required.`,
              },
            ]}
          >
            <Input ref={ref} />
          </Form.Item>
        </Form>
      </RootModal>
    </>
  );
}
